export const ERR_OK = 200

export const TIMEOUT = 3000

export const STATUS = 'status' // 后台返回的状态码，如 code status 这些

export const baseURL = {
  dev: 'http://localhost:8080/',
  prod: '/'
}
export const baseIP = 'http://111.202.159.17:60027'



// WEBPACK FOOTER //
// ./src/api/config.js